/**
 * Constantes del flujo de Mercado Pago (pasos y polling del Challenge 3DS).
 */

/** Pasos del flujo del checkout Mercado Pago */
export const STEPS = {
  LOADING: 'loading',
  CARDS: 'cards',
  FORM: 'form',
  EDIT_CARD: 'edit_card',
  SUMMARY: 'summary',
  PROCESSING: 'processing',
  CHALLENGE: 'challenge',
};

/** Configuración del polling para verificar estado del pago tras Challenge 3DS */
export const CHALLENGE_POLLING = {
  MAX_ATTEMPTS: 10,
  DELAY_MS: 2000,
};
